// extracted by mini-css-extract-plugin
export default {"header":"Datatypes_header__+yxoM","arrowIcon":"Datatypes_arrowIcon__GGzT4"};